<template>
    <select v-model="departureArea" name="" id="dep_area">
        <option value="">
            選択してください
        </option>
        <option v-for="(value, key) in departureAreaItemList" :value="key">
            {{ value.name }}
        </option>
    </select>
</template>

<script>
    import { ref, watchEffect } from 'vue'
    export default ({
        props: {
            // 引数の受け問
            master : {type: Object, require: true},
            condition : {type: Object, require: true},
        },
        emits: ['departureArea'],
        setup (props, context) {
            const departureArea = ref(props.condition.selectedDepartureArea.value)

            watchEffect(() => {
                context.emit("departureArea", departureArea);
            })

            // セットアップ。初期実行
            const departureAreaItemList = JSON.parse(props.master.departureAreaItemList)
            return {
                departureAreaItemList,
                departureArea,
            }
        },
    })
</script>